import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { individualCreatorPausePath, individualCreatorStagePath, newAccountPath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { IndividualBioStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  bio: string | null;
}

type FormData = {
  bio: string;
};

const IndividualBioStep = ({ stage_index, stage_order, bio }: PageProps) => {
  const { form, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => individualCreatorStagePath(stage),
      entryUrl: newAccountPath(),
      pauseUrl: individualCreatorPausePath(),
    },
    stageName: "bio",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { bio: bio ?? "" },
  });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.individuals.creator.steps.bio.show.meta_title")}>
        <meta name="description" content={t("web.individuals.creator.steps.bio.show.meta_description")} />
      </Head>
      <IndividualBioStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={form.data.bio}
        onChange={(val) => form.setData("bio", val)}
      />
    </>
  );
};

export default IndividualBioStep;
